import {parseCookies} from 'nookies'
import {Box, Text} from '@chakra-ui/react'
import {SelectedShippingMethod, Showroom} from '_app/types/api'
import {INPOST_METHOD} from 'modules/checkout/constants'
import {useCheckoutContext} from '../../hooks'
import ShowroomInfo from '../ShowroomInfo'

type Props = {
  selectedShippingMethod: SelectedShippingMethod;
  showRoom: Showroom | undefined;
};

export const FirstStepInfo = ({ selectedShippingMethod, showRoom }: Props) => {
  const { inpostAddress } = useCheckoutContext()
  const { inpostAddress: secondaryInpostAddress } = parseCookies()
  const showShowroomInfo =
    showRoom && selectedShippingMethod?.method_code === 'showroom'
  const inpost = selectedShippingMethod?.paczkomaty_target_point
  const showParcelLockerInfo =
    inpost && selectedShippingMethod?.method_code === INPOST_METHOD

  return (
    <Box mt={2} ml={7} textStyle="bodyLight">
      <Text>{selectedShippingMethod?.method_title}</Text>

      {showShowroomInfo && <ShowroomInfo showroom={showRoom} />}

      {showParcelLockerInfo && (
        <>
          <Text>{inpost}</Text>
          <Text>{inpostAddress || secondaryInpostAddress}</Text>
        </>
      )}
    </Box>
  )
}
